module.exports = __webpack_public_path__ + "static/img/server_info.7702345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/server_info.png
// module id = 6zHh
// module chunks = 44